<template>
  <v-form ref="passwordForm" lazy-validation>
    <v-row v-if="target != null">
      <v-col cols="12" md="4" class="pa-0">{{ use_language.staff }} :</v-col>
      <v-col cols="12" md="8" class="pa-0 pb-4"><b>{{ target.name }} ({{ target.username }})</b></v-col>
    </v-row>
    <!-- เปลี่ยนของตัวเองต้องยืนยันรหัสผ่านปัจจุบัน ส่วน Admin เปลี่ยนให้คนอื่นไม่ต้อง -->
    <v-row v-if="isSelf">
      <v-col cols="12" md="4" class="pa-0">{{ use_language.current_password }} :</v-col>
      <v-col cols="12" md="8" class="pa-0">
        <v-text-field
          v-model="currentPassword"
          :rules="rulesRequired"
          :type="showPassword ? 'text' : 'password'"
          autocomplete="current-password"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" class="pa-0">{{ use_language.new_password }} :</v-col>
      <v-col cols="12" md="8" class="pa-0">
        <v-text-field
          v-model="newPassword"
          :rules="rulesNewPassword"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          autocomplete="new-password"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" class="pa-0">{{ use_language.confirm_password }} :</v-col>
      <v-col cols="12" md="8" class="pa-0">
        <v-text-field
          v-model="newPassword2"
          :rules="rulesPassword2"
          :type="showPassword ? 'text' : 'password'"
          autocomplete="new-password"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0" align="right">
        <v-btn :elevation="1" color="primary" class="px-2" :loading="loading" @click="Save()">
          <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
          <span class="fn-14"><b> {{ use_language.record }} </b></span>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { changePassword } from '@/website/backend/oms/oms_service'

  // ฟอร์มเปลี่ยนรหัสผ่าน: target = null คือของตัวเอง, target = { staffShopID, name, username } คือ Admin เปลี่ยนให้ผู้ใช้อื่น
  export default {
    props: {
      target: { type: Object, default: null },
      isSelf: { type: Boolean, default: true }
    },
    data: () => ({
      use_language: getOmsLanguage(),
      loading: false,
      showPassword: false,
      currentPassword: null,
      newPassword: null,
      newPassword2: null,
      rulesRequired: [],
      rulesNewPassword: [],
      rulesPassword2: []
    }),
    methods: {
      reset () {
        this.currentPassword = null
        this.newPassword = null
        this.newPassword2 = null
        this.showPassword = false
        this.rulesRequired = []
        this.rulesNewPassword = []
        this.rulesPassword2 = []
      },
      async Save () {
        this.rulesRequired = [v => !!v || this.use_language.please_specify]
        this.rulesNewPassword = [v => !!v || this.use_language.please_specify]
        this.rulesPassword2 = [v => v === this.newPassword || this.use_language.password_mismatch]
        await this.$nextTick()
        if (!this.$refs.passwordForm.validate()) {
          return
        }
        this.loading = true
        const response = await changePassword({
          staffShopId: this.isSelf ? null : this.target.staffShopID,
          currentPassword: this.isSelf ? this.currentPassword : null,
          newPassword: this.newPassword
        })
        this.loading = false
        if (response.status != 'success') {
          this.$swal({
            position: 'top',
            type: 'error',
            text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
          })
          return
        }
        this.reset()
        this.$emit('done')
      }
    }
  }
</script>
